export const onRouteUpdate = () => {
    // Check if the 'updateConsent' function exists on the window object, and if not, create it
    // Add a "Link target" with value "javascript:updateConsent();" to any hyperlink that should trigger the modal
    if (!window.updateConsent) {
        window.updateConsent = () => {
            window?.Optanon?.ToggleInfoDisplay();
        };
    }
};
